import * as Yup from 'yup';

export const PermissionsSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .matches(/^[a-zA-Z0-9_ ]*$/, 'Name can only contain alphanumeric characters, underscores, and spaces'),
  isMandatory: Yup.boolean(),
  active: Yup.boolean(),
});
